import { isDefined } from '@frontend/sports/common/core/utils/extended-types';

export default class BetslipCombinator {
    private static combinations(combinationCount: number, itemsCount: number): number[][] {
        if (combinationCount === 0) {
            return [];
        }
        if (combinationCount === -1 || combinationCount === itemsCount) {
            // In order to support a combo with N items the combination count will be equal to itemsCount when it is -1
            return [[...Array(itemsCount).keys()]];
        }
        let comb = [...Array(combinationCount).keys()];
        const d = itemsCount - combinationCount;
        const matrix = [comb];
        for (let i = combinationCount; i--; ) {
            let k = comb[i];
            if (k < d + i) {
                comb = comb.slice();
                while (i < combinationCount) {
                    comb[i++] = ++k;
                }
                matrix.push(comb);
            }
        }

        return matrix;
    }

    combine<T>(systemItems: T[], systemBasis: number[], fixedItems: T[] = []): T[][] | never {
        const permutations = this.get(systemBasis, systemItems.length);
        const systems: T[][] = [];
        for (const permutation of permutations) {
            const picksPermutation: T[] = fixedItems.slice(); // Copy bankers in all systems.
            for (const index of permutation) {
                if (isDefined(systemItems[index])) {
                    picksPermutation.push(systemItems[index]);
                }
            }
            systems.push(picksPermutation);
        }

        return systems;
    }

    private get(systemBasis: number[], itemsCount: number): number[][] {
        return systemBasis.reduce((previous: number[][], current: number) => {
            return previous.concat(BetslipCombinator.combinations(current, itemsCount));
        }, []);
    }
}
